<template>
  <v-scale-transition>
    <kits-panel :kits-items="groupActivations">
      <h3 class="headline grey--text text-xs-center hidden-sm-and-down">
        Group Incentive
      </h3>
    </kits-panel>
  </v-scale-transition>
</template>

<script>
import { createGetParams } from '@/rest'

export default {
  components: {
    KitsPanel: () => import(/* webpackChunkName: "kitsPanel" */ '@/components/KitsPanel'),
  },
  data () {
    return {
      isFc: false,
      isSLD: false,
    }
  },
  computed: {
    groupActivations: function () {
      const menu = [
        {
          icon: 'mdi-account-multiple-plus-outline',
          path: '/GroupPrepaidAI',
          title: 'Group Prepaid AI',
          desc: 'Group activations.',
        },
        {
          icon: 'mdi-account-multiple-plus-outline',
          path: '/GroupBlackAI',
          title: 'Group Black AI',
          desc: 'Group activations.',
        },
      ]
      return menu
    },
  },
  mounted: function () {
    this.$rest.get('getDealerResources.php', createGetParams({})).then(function (response) {
      this.isFc = response.data.isFc
      this.isSLD = response.data.isSLD
    }.bind(this)).catch(error => {
      this.ecash = '<span style="color:red">' + error.message + '</span>'
    })
  },
}
</script>
